import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import Statement from 'src/feature/statement/view'
import {useStore} from 'src/feature/store/hook'
import {json} from 'stream/consumers'

const StoreInvoices = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, detailSet, tabFilter, tabFilterSet} = useStore()

  const Data = detail?.Invoice?.dataList || []
  const paging = detail?.Invoice?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'invoiceIssuerID',
      dataIndex: 'invoiceIssuerID',
      title: 'Ref No',
    },
    {
      key: 'InvoiceNo',
      dataIndex: 'invoiceNo',
      title: 'Invoice No',
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: 'Invoice Date',
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'invoiceIssuerName',
      dataIndex: 'invoiceIssuerName',
      title: 'Subscription Plan',
    },
    {
      key: 'DiscountAmount',
      dataIndex: 'discountedAmount',
      title: 'Paid Amount (AED)',
      render: (text: any) => <>{text.toFixed(2)}</>,
    },
    {
      key: 'Amount',
      dataIndex: 'amount',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.AMOUNT'}) + ' (AED)',
      render: (text: any) => <>{text.toFixed(2)}</>,
    },
    {
      key: 'InvoiceNo',
      dataIndex: 'invoiceNo',
      title: 'Payment Type',
      render: (text: string) => <>{text === '1' ? 'Cash' : 'Credit Card'}</>,
    },
    {
      key: 'InvoiceNo',
      dataIndex: 'invoiceNo',
      title: 'Invoice Issuer',
      render: (text: string) => <>{'MyFatoorah'}</>,
    },
  ]

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'STORE.DETAIL.INVOICES'})}
              </h3>
              <p className='text-muted fw-normal fs-6'>
                {intl.formatMessage({id: 'STORE.DETAIL.INVOICES_TOOLTIP'})}
              </p>
            </div>
          </div>
        </div>

        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              dataSource={Data}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detail || !detail.Invoice) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== detail.Invoice.paging.pageSize ? 1 : current

                  detailSet({
                    ...detail,
                    Invoice: {
                      ...detail.Invoice,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  })

                  tabFilterSet({
                    ...tabFilter,
                    paging: {
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'MENU.STATEMENT'})}</h3>
          </div>
        </div>
        <div className='card-body pt-0'>
          <Statement />
        </div>
      </div> */}
    </>
  )
}

export default StoreInvoices
